export default ({ get, checkStatus, toJSON }) => ({
  getShelf: (shelfIndex) =>
    get(`universe/v1/home_page_shelves/shelf_${shelfIndex}`)
      .then(checkStatus)
      .then(toJSON),
});
